export function checkNeedRingpool() {
  const elementForPreventDRP = document.createElement('div')
  elementForPreventDRP.setAttribute('id', 'w_ringpool')
  elementForPreventDRP.classList.add('drp-phone', 'wal-drp-phone')
  elementForPreventDRP.style.display = 'none'
  document.body.appendChild(elementForPreventDRP)
}
